<template>
  <q-card
    :flat="flat"
    class="storyCard"
    :class="{
      'bg-lightGrey': greyBG,
    }"
    :style="`max-width: 260px !important; min-width: 260px !important; height: ${
      largeVersion ? '342px' : '250px'
    }`"
  >
    <q-card-section v-if="data" class="q-pa-none">
      <q-img
        :style="`width: 260px; height: 180px; cursor: default`"
        :src="imageData"
      >
        <div class="full-width bg-transparent" style="padding: 10px !important">
          <div class="row justify-between">
            <div>
              <q-btn class="bg-accent expandStoryViewButton" icon="mdi-open-in-new" dense round
                     @click.stop="openExpandedView">
                <q-tooltip>
                  Expand full story card
                </q-tooltip>
              </q-btn>
            </div>
            <div class="row">
              <q-img
                v-for="(outcomeLink, index) in data.outcomes"
                :key="`storyCardOutcome_${index}`"
                v-if="
                  outcomeLink.outcome_id &&
                  outcomeKeyReferenceList[outcomeLink.outcome_id]
                "
                class="q-mx-auto q-mr-md"
                style="width: 24px; height: 24px"

                :src="
                  getOutcomeImage({
                    name: outcomeKeyReferenceList[outcomeLink.outcome_id].name,
                  })
                "
              >
                <q-tooltip>
                  {{ outcomeKeyReferenceList[outcomeLink.outcome_id].label }}
                </q-tooltip>
              </q-img>
            </div>
          </div>
        </div>
      </q-img>
    </q-card-section>
    <q-card-section v-if="data">
      <div class="row">
        <div class="col-12">
          <q-scroll-area
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
            style="width: 100%; height: 50px"
          >
            <h4 class="q-my-none">
              {{ data.title }}
            </h4>
          </q-scroll-area>
        </div>
        <div class="col-12 q-py-sm" v-if="data.completed_at && largeVersion">
          {{ data.completed_at | momentFormatMonthDayYear }}
        </div>
        <div v-if="largeVersion" class="col-12 q-pt-sm">
          <q-scroll-area
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
            style="width: 100%; height: 40px"
          >
            {{ data.description }}
          </q-scroll-area>
        </div>
      </div>
    </q-card-section>
    <ExpandedStoryView :is-visible="isShowingExpandedStory" :close-function="closeExpandedView" :story="data" />
  </q-card>
</template>

<script>
import { mapGetters } from "vuex";
import { getCSSVars } from "@/functions/cssVars";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
import ExpandedStoryView from "@/components/storyCards/ExpandedStoryView.vue";
import {loadImageToDataUrl} from "@/utils/imageUtils";

export default {
  props: {
    data: {
      default: null,
    },
    imageDataProp: {
      default: null,
    },
    largeVersion: {
      default: true,
      type: Boolean,
    },
    greyBG: {
      default: false,
      type: Boolean,
    },
    flat: {
      default: true,
      type: Boolean,
    },
  },
  components: {ExpandedStoryView},
  computed: {
    ...mapGetters({
      outcomeKeyReferenceList: "outcomes/keyReferenceList",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
  },

  data: () => ({
    isShowingExpandedStory: false,
    imageData: null,
  }),
  watch: {
    data: async function() { await this.refreshImageData(); },
    imageDataProp: async function() { await this.refreshImageData(true); }
  },
  async mounted() {
    await this.refreshImageData();
  },
  methods: {
    getOutcomeImage: getOutcomeImage,
    getCSSVars: getCSSVars,
    async refreshImageData (isRawData=false) {
      if(isRawData) this.imageData = this.imageDataProp;
      else this.imageData = await loadImageToDataUrl(this.data.imgUrl ?? 'https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/oatas_default.png')
    },
    openExpandedView() {
      this.isShowingExpandedStory = true;
    },
    closeExpandedView() {
      this.isShowingExpandedStory = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.storyCard {
  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: $accent;
    line-height: 1.1rem;
  }
}

.storyCard .expandStoryViewButton {
  visibility: hidden;
}

.storyCard:hover .expandStoryViewButton {
  visibility: visible;
}
</style>
